import { Visibility, VisibilityOff } from '@mui/icons-material';
import type { TextFieldProps } from '@mui/material';
import { InputAdornment, TextField, styled } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '~/components/IconButton';

const ToggleIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.dark,
}));

export interface PasswordFieldProps
  extends Omit<TextFieldProps, 'autoComplete' | 'type' | 'margin' | 'variant'> {
  kind?: 'current' | 'new';
}

export const PasswordField = ({ kind = 'current', ...props }: PasswordFieldProps) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      autoComplete={kind === 'current' ? 'current-password' : 'new-password'}
      type={showPassword ? 'text' : 'password'}
      margin="dense"
      variant="outlined"
      InputProps={{
        ...props.InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <ToggleIconButton
              label={
                showPassword ? t('common.actions.hide_password') : t('common.actions.show_password')
              }
              disabled={props.disabled}
              onClick={() => setShowPassword(!showPassword)}
              onMouseDown={(event) => event.preventDefault()}
              edge="end"
              size="large"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </ToggleIconButton>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
};
